export const getTeamPlanningMessageType = (message) => {
  const normalizedMessage = (message || "").toLowerCase();

  if (
    normalizedMessage.includes("not authorized") ||
    normalizedMessage.includes("not found") ||
    normalizedMessage.includes("no record")
  ) {
    return "error";
  }

  if (
    normalizedMessage.includes("read-only") ||
    normalizedMessage.includes("exists")
  ) {
    return "warning";
  }

  return "success";
};

export const isTeamPlanningSuccessMessage = (message) =>
  getTeamPlanningMessageType(message) === "success";
